import type { GetPermissionsListingDTO } from '@bb/domain/dist/types/dto/AppointmentController/getPermissionsListing';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const getPermissionsListing = async (listingId: string) => {
  const config: AxiosRequestConfig = {
    url: `/listing/${listingId}/appointments/permissions`,
    method: 'get',
  };
  const { data } = await axios.request<GetPermissionsListingDTO>(config);
  return data;
};

export default getPermissionsListing;
